<template>
  <div>Clearing Token...</div>
</template>

<script>
import router from '@/router/routes';

export default {
  mounted() {
    console.log('clearing');
    localStorage.removeItem('access_token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
    this.$store.commit('AUTHENTICATED', false);
    this.$store.commit('CLOAKED', false);
    router.push('/');

  },
};
</script>
